module.exports = __webpack_public_path__ + "img/consultant_accept.ae6fb2cd.png";